import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=2cfaf63a"
import script from "./Response.vue?vue&type=script&lang=js"
export * from "./Response.vue?vue&type=script&lang=js"
import style0 from "./Response.vue?vue&type=style&index=0&id=2cfaf63a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cfaf63a')) {
      api.createRecord('2cfaf63a', component.options)
    } else {
      api.reload('2cfaf63a', component.options)
    }
    module.hot.accept("./Response.vue?vue&type=template&id=2cfaf63a", function () {
      api.rerender('2cfaf63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Partials/Response.vue"
export default component.exports